// extracted by mini-css-extract-plugin
export var input = "NumberPicker-module--input--2h9v-";
export var btn = "NumberPicker-module--btn--2De7f";